import { ViewService } from '@xeetr/types/models'

import HeaderBadges from '../common/HeaderBadges'
import OrderButtons from '../common/OrderButtons'

import { Badge } from '@/components/ui/badge'

interface Props {
  service: ViewService
  serviceIndex: number
  services: ViewService[]
  swapService: (fromIndex: number, toIndex: number) => void
}

const ServiceHeader = ({ service, serviceIndex, services, swapService }: Props) => {
  const orderUp = () => {
    if (serviceIndex === 0) return
    swapService(serviceIndex, serviceIndex - 1)
  }

  const orderDown = () => {
    if (serviceIndex === services.length - 1) return
    swapService(serviceIndex, serviceIndex + 1)
  }

  return (
    <div className="flex w-full justify-between">
      <div className="ml-2 flex flex-col gap-1">
        <span className="text-2xl font-normal">{service.name}</span>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-center">
          <Badge variant={service.active ? 'default' : 'destructive'}>
            {service.active ? 'Aktiv' : 'Inaktiv'}
          </Badge>
          <Badge variant={service.onlineAvailable ? 'default' : 'destructive'}>
            {service.onlineAvailable ? 'Online Reservierbar' : 'Nicht Online Reservierbar'}
          </Badge>
          <HeaderBadges values={service.categories} length={3} />
        </div>
      </div>
      <OrderButtons
        disabledUp={serviceIndex === 0}
        onUp={orderUp}
        disabledDown={serviceIndex === services.length - 1}
        onDown={orderDown}
      />
    </div>
  )
}

export default ServiceHeader
